(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    var locale = document.documentElement.lang || 'en-IN';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(0);
    }
  }

  function cardHTML(product, opts) {
    opts = opts || {};
    var title = opts.title || product.title;
    var descRaw = opts.description || product.description || '';
    var desc = descRaw.replace(/<[^>]*>/g, '').trim();
    if (desc.length > 150) desc = desc.slice(0, 150).trim() + '…';
    var cta = opts.cta || 'Shop now';
    var url = '/products/' + product.handle;
    var image = product.featured_image || (product.images && product.images[0]) || null;
    var price = product.price;

    var html = '<div class="bpb-card bpb-loaded">';
    html += '<a href="' + url + '" class="bpb-image-link">';
    if (image) {
      html += '<img class="bpb-image" src="' + image + '&width=800" ' +
              'srcset="' + image + '&width=400 400w, ' + image + '&width=800 800w" ' +
              'sizes="(min-width: 750px) 50vw, 100vw" loading="lazy" alt="' + title.replace(/"/g, '&quot;') + '">';
    } else {
      html += '<div class="bpb-image bpb-image--placeholder"></div>';
    }
    html += '</a>';

    html += '<div class="bpb-content">';
    html += '<a href="' + url + '" class="bpb-title-link"><h3 class="bpb-title">' + title + '</h3></a>';
    if (desc) {
      html += '<p class="bpb-description">' + desc + '</p>';
    }
    html += '<div class="bpb-price"><span class="bpb-price-regular">' + formatMoney(price) + '</span></div>';
    html += '<a href="' + url + '" class="bpb-cta">' + cta + '<span class="bpb-cta-arrow">→</span></a>';
    html += '</div>';
    html += '</div>';
    return html;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function (r) {
      if (!r.ok) throw new Error('Product not found: ' + handle);
      return r.json();
    });
  }

  function initGroups() {
    var groups = document.querySelectorAll('.bpb-embed-group');
    if (!groups.length) return;

    var dataEl = document.getElementById('bpb-featured-products-data');
    var handles = [];
    if (dataEl) {
      try {
        var list = JSON.parse(dataEl.textContent);
        handles = list.map(function (item) { return item.handle; }).filter(Boolean);
      } catch (e) {
        handles = [];
      }
    }

    groups.forEach(function (group) {
      if (!handles.length) {
        group.innerHTML = '';
        return;
      }
      group.classList.add('bpb-group-grid', 'bpb-loading');
      Promise.all(handles.map(function (h) { return fetchProduct(h).catch(function () { return null; }); }))
        .then(function (products) {
          group.classList.remove('bpb-loading');
          var html = '';
          products.forEach(function (product) {
            if (product) html += cardHTML(product);
          });
          group.innerHTML = html;
        });
    });
  }

  function initSingles() {
    var embeds = document.querySelectorAll('.bpb-embed[data-product-handle]');
    embeds.forEach(function (el) {
      var handle = el.getAttribute('data-product-handle');
      if (!handle) return;
      el.classList.add('bpb-loading');
      fetchProduct(handle)
        .then(function (product) {
          el.outerHTML = cardHTML(product, {
            title: el.getAttribute('data-title'),
            description: el.getAttribute('data-description'),
            cta: el.getAttribute('data-cta')
          });
        })
        .catch(function () {
          el.classList.add('bpb-error');
          el.innerHTML = '<p class="bpb-error-text">Product unavailable</p>';
        });
    });
  }

  function init() {
    initGroups();
    initSingles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
